import { ActionContract } from "./registry-contract";

export class AgentActionRouteController {
  // @ngInject
  constructor(
    $state: ng.ui.IStateService,
    $compile: ng.ICompileService,
    $scope: ng.IScope | any,
    $element: ng.IRootElementService
  ) {
    let content = $state.params["content"];
    let childScope = $scope.$new(true);
    let actionContract = <ActionContract<any>>$state.params["actionContract"];
    childScope.actionContext = actionContract.actionContext;
    childScope.actionDeferral = actionContract.actionDeferral;
    childScope.isActionHost = true;
    $element.append($compile(content)(childScope));
  }
}
